import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

const initialState = {
  ratings: [],
  myRatings: [],
  allRatings: [],
  loading: false,
  historyLoading: false,
  adminLoading: false,
  error: null,
};

export const rateRepresentative = createAsyncThunk(
  'rating/rateRepresentative',
  async (
    { representativeId, representativeUserId, rating, comment },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.post('/rating/representative', {
        representativeId,
        representativeUserId,
        rating,
        comment,
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const rateResolution = createAsyncThunk(
  'rating/rateResolution',
  async (
    { representativeId, representativeUserId, rating, comment },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.post('/rating/resolution', {
        representativeId,
        representativeUserId,
        rating,
        comment,
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchMyRatings = createAsyncThunk(
  'rating/fetchMyRatings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/rating/my');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAllRatingsForAdmin = createAsyncThunk(
  'rating/fetchAllRatingsForAdmin',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/rating/admin/all');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const ratingSlice = createSlice({
  name: 'rating',
  initialState,
  reducers: {
    clearRatingError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(rateRepresentative.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rateRepresentative.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings.push(action.payload);
      })
      .addCase(rateRepresentative.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(rateResolution.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rateResolution.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings.push(action.payload);
      })
      .addCase(rateResolution.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMyRatings.pending, (state) => {
        state.historyLoading = true;
      })
      .addCase(fetchMyRatings.fulfilled, (state, action) => {
        state.historyLoading = false;
        state.myRatings = action.payload || [];
      })
      .addCase(fetchMyRatings.rejected, (state, action) => {
        state.historyLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllRatingsForAdmin.pending, (state) => {
        state.adminLoading = true;
      })
      .addCase(fetchAllRatingsForAdmin.fulfilled, (state, action) => {
        state.adminLoading = false;
        state.allRatings = action.payload || [];
      })
      .addCase(fetchAllRatingsForAdmin.rejected, (state, action) => {
        state.adminLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearRatingError } = ratingSlice.actions;

export default ratingSlice.reducer;
